<template>
    
	<section class="section">

	<svg height="0" width="0" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.04 148.97">
		<defs></defs>
		<clipPath id="rose" clipPathUnits="objectBoundingBox" transform="scale(0.01148897,0.00671276)">
		<path class="cls-1" d="M34,.5C24.44.5,21.16,5.78,14.59,11.7.79,28.78.5,58.35.5,74.5S11.3,93.83,15.57,105s-2,22.67,1.32,32.52,7.23,12.81,14.78,9.86S47.11,117.5,54,106.64s29.24-20,31.87-40.08-3-42.46-10.51-52.23S43.5.5,34,.5Z"/>
		</clipPath>
	</svg>

	<svg  height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.28 541"><defs></defs>
		<clipPath id="transp" clipPathUnits="objectBoundingBox" transform="scale(0.00179443008,0.00184842883)">
		<path d="M556.4,277.56c8.43,196.17-125.2,262.91-278.22,262.91C178.56,542.64-20.31,437.33,2.27,277.56S107.09.5,279.33.5,548,81.39,556.4,277.56Z" transform="translate(0)"/>
		</clipPath>
	</svg>

	<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.53 129">
		<defs>
		</defs>
		<clipPath id="bleu" clipPathUnits="objectBoundingBox" transform="scale(0.00622936522,0.00775193798)">
		<path class="cls-1" d="M102.36,16.79c-15,0-8,15-27,20.5s-65-13.5-73,23.5,22,37.48,35,48c12,9.72,17,36,65,36s46-12,56-31-17-69-24-83S117.36,16.79,102.36,16.79Z" transform="translate(-0.53 -16.29)"/>
		</clipPath>
	</svg>

	<div class="container">    


		<div class="row justify-content-between align-items-center">
			<div class="col-sm-6 content">
				<p class="citation">
L'oiseau perché dans l'arbre ne craint pas que la branche casse parce que sa confiance n'est pas dans la branche mais dans ses ailes.
				</p>

				<div class="row justify-content-around" style="height: 50px;">
				</div>
				<div class="gauche">
					<transition name="FadeSlide1" appear ><img  src="../assets/img/nasa-08-jaune.svg"></transition>
				</div>
				<div class="entreprises" style="">
					<h3>Chef d'entreprise, vous êtes soucieux du bien-être de vos salariés !</h3>

					<p>La sophrologie peut vous <span style="font-weight:bold;">Aider</span> à améliorer le bien-être et la performance de vos collaborateurs.</p>

					<p>La méthode est <span style="font-weight:bold;">douce</span> et <span style="font-weight:bold;">positive</span>.</p>

					<p>Chaque personne vit sa propre expérience en tant qu'<span style="font-weight:bold;">individu</span> et, en parallèle, des <span style="font-weight:bold;">bénéfices communs</span> sont ressentis par tous au sein de l'entreprise.
					</p>

					<p>
						<span style="font-weight:bold;">Quelques exemples d'objectifs :</span>
					</p>

				</div>

			</div>

			<div class="col-sm-6">
				<div  style="position:inherit;z-index:5;">
					<img class="img-fluid" style="-webkit-clip-path:url(#transp);clip-path:url(#transp);max-width:80%;" src="../assets/img/pictpro01.jpg">
				</div>
				<div>
					<transition name="FadeSlide2" appear ><img class="centre" style="" src="../assets/img/nasa-01-blanc.svg"></transition>
				</div>
				<div>
					<transition name="FadeSlide3" appear ><img class="droite" style="" src="../assets/img/nasa-08-mauve.svg"></transition>
				</div>

			</div>
	
			<div class="col-sm-4 entreprises">
				<p>
Faire une pause et se ressourcer pour être plus disponible à soi et aux autres
				</p>
			</div>
			<div class="col-sm-4 entreprises">
				<p>
Relâcher la pression, libérer les tensions corporelles et mentales, booster la créativité
				</p>
			</div>
			<div class="col-sm-4 entreprises">
				<p>
Améliorer la communication et l'écoute de l'autre. Gérer le stress, le trac ...
				</p>
			</div>
		</div>

	</div>    


	</section>
</template>


<script>

export default {
  name: 'Entreprises',
  metaInfo: function(){
	return{
    title: "Emmanuelle Vignon",
    titleTemplate: '%s | Sophrologue en Entreprises',
        meta: [
      { hid: "description", name: "description", content: " Vous êtes chef d'entreprise, la sophrologie peut vous aider à améliorer le bien-être et la performance de vos collaborateurs." },
      { hid: "keywords", name: "keywords", content: " performances, cohésion d'équipe, communication, gestion de la pression, gérer la pression, qualité de vie au travail, relations humaines, risques psycho-sociaux, troubles musculo-squelettiques, adaptation au changement, burn out " }      //you can also add open graph tags here
    ]
  }}
  }
</script>


<style scoped>
.entreprises{
	z-index: 4;
	position: relative;
}
.entreprises p{
	font-size: 16px;
	padding-top:10px;
}
.entreprises h3{
	font-weight: 500;
}
.centre{
	height: 75%;
background: none;
position: absolute;
width: 75%;
z-index: 1;
bottom: -10%;
left: 5%;
}
.gauche{
	height: 60%;
position: absolute;
width: 50%;
z-index: 1;
bottom: -10%;
left: -35%;
clip-path:url(#rose);
-webkit-clip-path:url(#rose);
}
.droite{
	height: 75%;
position: absolute;
z-index: 1;
bottom: -5%;
right: 5%;
}

/*$$$$$$$$$ ANIMATIONS IMAGES $$$$$$$$*/

.FadeSlide1-enter-active, .FadeSlide1-leave-active {
  transition: all 10s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide1-enter, .FadeSlide1-leave-to  {
  opacity: 0;
  transform: translate(-50px,0);
}
.FadeSlide2-enter-active, .FadeSlide2-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide2-enter, .FadeSlide2-leave-to {
  opacity: 0;
  transform: translate(25px,-25px);
}
.FadeSlide3-enter-active, .FadeSlide3-leave-active {
  transition: all 6s cubic-bezier(.06, .97, .49, 1);
}
.FadeSlide3-enter, .FadeSlide3-leave-to {
  opacity: 0;
  transform: translate(-25px,-25px);
}
</style>
